import mutations from "@/store/mutations/gxUserInfoMutaion";
import getters from "@/store/getters/gxUserInfoGetter";
import actions from "@/store/actions/gxUserInfoAction";
/**
 * [GX] GX service DATA
 */
export default {
  state: {
    gxUserInfo: {},
    gxServiceList: [],
    subsList: [],
    freeFollowersEnable: true // 本地字段，存储首屏弹窗是否可以执行新用户送followers逻辑
  },
  mutations,
  getters,
  actions
};